import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { browserHistory } from 'react-router';
import AddShippingAddressOverlayDialogVerify from '../../dialogs/addShippingAddressOverlayDialogVerify';
import AccountNumberContainers from '../common/accountNumberContainers';
import {
	createGECustomerNetRegistration,
	getAddressVerificationData,
	showAddressVerificationDialog,
	saveIsAnyValidAccountNumber,
	getAdminEmailAddress,
	dropProductSpecsEmail,
	getSalesRepId,
	getSSOFromSalesRepId,
	saveAddressVerificationData,
	logout,
} from '../../../redux/actions';
import RequestAccessSucessLogoutDialog from '../../dialogs/requestAccessSuccessLogoutDialog';
import { routes } from '../../../redux/api/routes';
import ShipToAddress from '../../common/shipToAddress'; 
let { localStorageVar } = routes;

class GECustNetRegistration extends Component {

    constructor(props){
        super(props);
        this.state = {
			showRequestAccessSucessLogoutDialog : false,
			body: null,
			ignoreList: [-3],
			errorMessage: '',
			showAddMoreAccountsLink: true,
			geCustomerNetRegistrationForm: {
				params: {
					gessouid: ''
				}
			},
			parallelCallCount: 0,
        };
		this.handleUseSelectedAddress = this.handleUseSelectedAddress.bind(this);
		this.handleEditAddress = this.handleEditAddress.bind(this);
		this.checkAllParallelCallsAreCompleted = this.checkAllParallelCallsAreCompleted.bind(this);
		this.dropAnEmail = this.dropAnEmail.bind(this);
		this.updateAddressFieldsFromSuggestedAddress = this.updateAddressFieldsFromSuggestedAddress.bind(this);
    }

	handleAddMoreAccounts(event) {
		event.preventDefault();
		this.setState({
			showAddMoreAccountsLink: false
		});
	}

	componentWillMount() {
		window.scrollTo(0, 0);
		// let { registration } = this.props.state;
		// if(!registration.ssoRegistrationParams) {
		// 	//redirect to sso registration page if user directly comes on this page
		// 	browserHistory.push("/login");
		// }
	}

	componentDidMount() {
		var localStorageObj = this.props.getLocalStorageVar(localStorageVar);
		if(localStorageObj) {
			var self = this;

			self.setState({
				geCustomerNetRegistrationForm: {
					...self.state.geCustomerNetRegistrationForm,
					params: {
						...self.state.geCustomerNetRegistrationForm.params,
						gessouid: self.props.state.user.userDetails.gessouid,
						userId: self.props.state.user.userDetails.sso
					}
				}
			})
			self.props.removeLocalStorageVar(localStorageVar);
		} else {
			browserHistory.push("/login");
		}
	}

	handleGECustNetRegistrationSubmit = addressData => {
		const self = this,
			{ registration: { geAccountNumbers } } = self.props.state;
		// //check if any valid account is passed
		// var validAccount = _.filter(this.props.state.registration.geAccountNumbers, ["valid", true]);
		// formError = validAccount.length === 0?true:formError;

		// self.props.saveIsAnyValidAccountNumber(validAccount.length === 0?false:true);
		self.props.showAddressVerificationDialog(false);
		self.setState({
			errorMessage: '',
			parallelCallCount: _.filter(geAccountNumbers, item => item.accountNumber).length,
		}, () => {
			if (self.state.parallelCallCount === 0) {
				// Show message to enter at least one valid account number
				self.props.saveIsAnyValidAccountNumber(false);
			}
			geAccountNumbers.forEach((item, index) => {
				if (item.accountNumber) {
					self.props.validateAccountNumber(index + 1, item.accountNumber, () => {
						const parallelCallCount = self.state.parallelCallCount;
						self.setState({
							parallelCallCount: parallelCallCount - 1,
						}, () => {
							if (self.state.parallelCallCount === 0) {
								if (!_.find(geAccountNumbers, ["valid", false])) {
									var phoneNumber = addressData.phoneNumber.replace(" ", "").replace("-", "").replace("(", "").replace(")", "").trim();
									// addressData.phoneNumber = phoneNumber;
									const { addressLine1: address1, addressLine2: address2, addressLine3: address3, ...rest } = JSON.parse(JSON.stringify(addressData));
									let body = {
										...rest,
										address1,
										address2,
										address3,
										phoneNumber,
										// gessouid: this.state.geCustomerNetRegistrationForm.params.gessouid,
										userId: this.state.geCustomerNetRegistrationForm.params.userId
									},
										gessouid = this.state.geCustomerNetRegistrationForm.params.gessouid;
									body = _.extend(body, this.props.state.registration.ssoRegistrationParams);
									body.gessouid = gessouid;
									delete body.confirmEmailAddress;
									delete body.confirmPassword;
									body.accounts = [];
									this.props.state.registration.geAccountNumbers.forEach((item) => {
										if (item.valid === true) {
											body.accounts.push({
												accountNumber: item.accountNumber,
												userId: this.props.state.user.userDetails ? this.props.state.user.userDetails.sso : '',
												userRole: item.userRole,
												approvalStatus: "Pending",
												accountName: item.accountName,
												companyName: item.companyName && item.companyName.trim()
											});
										}
									});
									self.setState({
										body
									}, () => {
										if (['US', 'CA'].includes(body.country)) {
											const state = body.country === 'US' ? body.state : body.province;  //don't mutate body
											const zipCode = body.country === 'US' ? body.zipCode : body.postalCode; //don't mutate body
											const queryString = "address1="+encodeURIComponent(body.address1)+"&address2="+encodeURIComponent(body.address2)+"&city="+body.city+"&state="+state+"&zip="+zipCode+"&country="+body.country+"&requestType=validateAddress";
											self.props.getAddressVerificationData(queryString, (response) => {
												self.props.showAddressVerificationDialog(true);
											});
										} else {
											self.props.saveAddressVerificationData(null);
											self.props.showAddressVerificationDialog(true);
										}
									});
								} else {
										// Show message to enter at least one valid account number
										self.props.saveIsAnyValidAccountNumber(false);
								}
							}
						});
					});
				}
			});
		});
	}

	handleUseSelectedAddress(enteredAddressIsCorrectOrNot, event) {
		event.preventDefault();
		//If entered address is selected
		var self = this,
			body = this.state.body;

		if(!enteredAddressIsCorrectOrNot) {
			body = this.updateAddressFieldsFromSuggestedAddress();
		} else {
			if (body.country !== 'US') {
				body = {
					...body,
					zipCode: body.postalCode,
					state: (body.state || '').trim() || body.province
				}
				if (body.country !== 'CA' && (!body.zipCode || !body.zipCode.trim())) {
					body.zipCode = '00000';
				}
			}
		}
		const accountsList = [];
		body.accounts.forEach((item, index) => {
			if (!item.userRole) {
				accountsList.push(item.accountNumber);
			}
		});
		self.setState({
			body,
			errorMessage: '',
			adminEmailServiceCallCompleted: false,
			isDLEmailIdServiceCallCompleted: false,
		}, () => {
			//hide address selection dialog
			self.props.showAddressVerificationDialog(false);

			//After hiding make service call of registration
			self.props.createGECustomerNetRegistration(body, (response) => {
				if(response.status) {
					if (accountsList.length) {
						self.props.getAdminEmailAddress(`requestType=getAdminsOfAccounts&accountNumbers=${accountsList.join(",")}`, response => {
							if(response.status) {
								self.setState({
									adminEmailData: response.responseObject,
									adminEmailServiceCallCompleted: true
								}, () => {
									self.dropAnEmail();
								});
							} else {
								self.setState({
									errorMessage: response.responseMessage
								});
							}
						});
						// getSalesRepId
						self.setState({
							noOfParallelCalls: accountsList.length,
							noOfCompletedParallelCall: 0,
							dlEmailDataList: [],
						}, () => {
							accountsList.forEach(accountNumber => {
								self.props.getSalesRepId(`accountNumber=${accountNumber}&requestType=getSalesRepId`, resp => {
									if(resp.status) {
										if(typeof resp.responseObject !== 'string' && resp.responseObject && resp.responseObject.length) {
											let paramList = [];
											resp.responseObject.forEach((item) => {
												const {
													ASM_ID,
													DSASMID,
													KEYACCOUNT_ASM
												} = item;
												if(ASM_ID && paramList.indexOf(ASM_ID) === -1) {
													paramList.push(ASM_ID);
												}
												if(DSASMID && paramList.indexOf(DSASMID) === -1) {
													paramList.push(DSASMID);
												}
												if(KEYACCOUNT_ASM && paramList.indexOf(KEYACCOUNT_ASM) === -1) {
													paramList.push(KEYACCOUNT_ASM);
												}
											});
											paramList = paramList.filter(item => self.state.ignoreList.indexOf(item) === -1);
											const accountNum = resp.responseObject[0].ACCOUNT_NUMBER;
											self.props.getSSOFromSalesRepId(`requestType=getSSOFromSalesRepId&salesRepId=${paramList.join(',')}`, respn => {
												if(respn.status) {
													if(respn.responseObject && respn.responseObject.length) {
														const { dlEmailDataList } = self.state;
														dlEmailDataList.push({
															accountNumber: accountNum,
															emailData:respn.responseObject
														});
														self.setState({
															dlEmailDataList,
															noOfCompletedParallelCall: self.state.noOfCompletedParallelCall + 1,
														}, () => {
															self.checkAllParallelCallsAreCompleted();
														});
													} else {
														self.setState({
															noOfCompletedParallelCall: self.state.noOfCompletedParallelCall + 1,
														}, () => {
															self.checkAllParallelCallsAreCompleted();
														});
													}
												} else {
													browserHistory.push('/error');
												}
											});
										} else {
											//This will update store with asm indicator
											self.props.updateUserASMOrNot(false);
											self.checkForOtherAccountASM();
										}
									} else {
										browserHistory.push('/error');
									}
								});
							});
						});
					} else {
						self.setState({
							showRequestAccessSucessLogoutDialog: true
						});
					}
			 	} else {
			 		self.setState({
			 			errorMessage: response.responseMessage
			 		})
			 	}
			});
			window.scrollTo(0, 0);
		});
	}

	checkAllParallelCallsAreCompleted() {
		const self = this;
		const {
			noOfParallelCalls,
			noOfCompletedParallelCall
		} = self.state;
		if(noOfParallelCalls === noOfCompletedParallelCall) {
			self.setState({
				isDLEmailIdServiceCallCompleted: true
			}, () => {
				self.dropAnEmail();
			});
		}
	}

	dropAnEmail() {
		const self = this;
		const {
			adminEmailServiceCallCompleted,
			isDLEmailIdServiceCallCompleted,
			adminEmailData,
			dlEmailDataList,
			body,
		} = self.state;
		if(adminEmailServiceCallCompleted && isDLEmailIdServiceCallCompleted) {
			const { userDetails } = self.props.state.user;
			const adminDetails = adminEmailData;
			dlEmailDataList.forEach(item => {
				item.emailData.forEach(itm => {
					adminDetails[item.accountNumber].push({
						userId: itm.SALESREP_NUMBER,
						emailAddress: itm.SALESREP_NUMBER + '@geappliances.com',
					});
				});

			});
			const payload = {
				userName: userDetails.firstName + " " + userDetails.lastName,
				userId: body.userId,
				userEmail: userDetails.email,
				adminDetails,
				status:"Pending"
			}
			self.props.dropProductSpecsEmail(payload, "emailType=Registration", resp => {
				if(resp.status) {
					self.setState({
						showRequestAccessSucessLogoutDialog: true
					})
					//browserHistory.push("/prelogin/ge-custnet-registration/confirmation");
				} else {
					browserHistory.push("/prelogin/error");
				}
			});
		}
	}

	logout(){
		var self = this;
		self.props.logout();
	}

	updateAddressFieldsFromSuggestedAddress() {
		var self = this,
			data = this.props.state.registration.addressVerificationData.responseObject,
			body = this.state.body;
		var address1 = data.addressline1.trim(),
			address2 = data.addressline2.trim(),
			address3 = data.addressline3 ? data.addressline3.trim() : undefined,
			city = data.city.trim(),
			state = data.state.trim(),
			zipCode = data.postalcode.trim(),
			postalCode = data.postalcode.trim();

		body = {
			...body,
			address1: address1,
			address2: address2,
			address3,
			city: city,
			state: state,
			zipCode: zipCode,
			emailAddress: this.props.state.user.userDetails.email,
			postalCode:postalCode,
		};
		self.setState({
			body: body
		});
		return body;
	}

	handleEditAddress(whichAddress, event) {
		event.preventDefault();
		if(whichAddress === "asCorrected") {
			this.updateAddressFieldsFromSuggestedAddress();
			//update fields with the response from the address api
			this.shipToAddressRef.updateFieldsWithFoundAddress(this.props.state.registration.addressVerificationData.responseObject);
		}
		//hide address selection dialog
		this.props.showAddressVerificationDialog(false);
	}

	handleSubmit = event => {
		event.preventDefault();

		for (const account of this.props.state.registration.geAccountNumbers) {
			if (account.accountNumber && account.accountNumber.trim() && (!(account.valid && account.isCheckedForSalesAgreements) ||
				(account.isOnlyGEAPartsSalesAgreementsAccount && !(account.userRole && account.companyName && account.companyName.trim())))) {
				return;
			}
		}

		this.shipToAddressRef.validateFields(this.handleGECustNetRegistrationSubmit.bind(this));
	};

    render() {
		const { registration, user } = this.props.state;
        return (
			<div>
				<form onSubmit={this.handleSubmit} className={"requestAccessToCustomerNetForm "+(!this.state.showAddMoreAccountsLink?"withAdditionalAccountNumberFields":"")} name="requestAccessToCustomerNetForm" id="requestAccessToCustomerNetForm">
				  	<div className="largePush">
						<h1 className="pageTitle uppercase">GE Appliances CustomerNet Registration</h1>
						<p className="red bold">{this.state.errorMessage}</p>
						<h2 className="noMarginBottom">User Name &amp; ID</h2>
						<p className="noMarginTop">{user.userDetails && user.userDetails.firstName} {user.userDetails && user.userDetails.lastName} — {user.userDetails && user.userDetails.sso}</p>
				  	</div>
				  	<div className="largePush">
						<p>Now that your Single Sign On ID and password have been created, you will need to complete the following information to gain access to GE Appliances CustomerNet.</p>
						<ShipToAddress ref={(el) => { this.shipToAddressRef = el; }} address={this.state.geCustomerNetRegistrationForm.params} context='REGISTRATION' {...this.props} />
				  	</div>
				  	<div className="largePush">
						<hr />
						<p>Enter the account number(s) you will need to access on GE Appliances CustomerNet. You may request up to 20 different accounts.<br />
						If you need access to more accounts, you will need to contact your Account Administrator.</p>
						<AccountNumberContainers acceptNumbersOnly={this.props.acceptNumbersOnly} handleAddMoreAccounts={this.handleAddMoreAccounts.bind(this)} showAddMoreAccountsLink={this.state.showAddMoreAccountsLink} getPriceSources={this.props.getPriceSources} />
				  	</div>
				  	<div className="errorMessageContainer" style={{display: 'none'}} />
					<p><input className="blueButton" type="submit" value="Submit Request" /></p>
				</form>
				{registration.showAddressVerificationDialog?<AddShippingAddressOverlayDialogVerify onChangeWhichAddress={this.onChangeWhichAddress} handleEditAddress={this.handleEditAddress} suggestedAddress={registration.addressVerificationData} existingAddress={this.state.body} handleUseSelectedAddress={this.handleUseSelectedAddress} showDialog={true}/>:null}
				{this.state.showRequestAccessSucessLogoutDialog?<RequestAccessSucessLogoutDialog  showDialog={true} logout ={this.logout.bind(this)} />:null }
			</div>
        );
    }
}

const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	createGECustomerNetRegistration: (data,callback) => dispatch(createGECustomerNetRegistration(data,callback)),
	getAddressVerificationData: (data, callback) => dispatch(getAddressVerificationData(data, callback)),
	showAddressVerificationDialog: (data) => dispatch(showAddressVerificationDialog(data)),
	saveIsAnyValidAccountNumber: (data) => dispatch(saveIsAnyValidAccountNumber(data)),
	getAdminEmailAddress: (data, callback) => dispatch(getAdminEmailAddress(data, callback)),
	saveAddressVerificationData: (data) => dispatch(saveAddressVerificationData(data)),
	getSalesRepId: (payload, callback) => dispatch(getSalesRepId(payload, callback)),
	getSSOFromSalesRepId: (payload, callback) => dispatch(getSSOFromSalesRepId(payload, callback)),
	dropProductSpecsEmail: (payload, hybridQueryParams, callback) => dispatch(dropProductSpecsEmail(payload, hybridQueryParams, callback)),
	logout: () => dispatch(logout()),
});

GECustNetRegistration = connect(mapStateToProps,mapDispatchToProps)(GECustNetRegistration);
export default GECustNetRegistration;



// WEBPACK FOOTER //
// ./src/App/components/PreLogin/GECustNetRegistration/index.js